/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CursorSearchEnrollmentScheduleResponseDto } from '../../models/cursor-search-enrollment-schedule-response-dto';

export interface EnrollmentScheduleControllerSearchCursorByTicketIdV1$Params {
  ticketId: string;

/**
 * 페이지 크기
 */
  pageSize: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어
 */
  query?: string;

/**
 * 커서
 */
  cursor?: string;

/**
 * 타입
 */
  type?: 'COUNSELING' | 'TREATMENT' | 'SUPPLEMENT' | 'ALL';

/**
 * 문서 작성 상태
 */
  logStatus?: 'PENDING' | 'COMPLETED';

/**
 * 연도
 */
  year?: string;

/**
 * 시작일
 */
  startAt?: string;

/**
 * 종료일
 */
  endAt?: string;

/**
 * 센터 ID
 */
  centerId?: string;

/**
 * 아동 ID
 */
  childId?: string;

/**
 * 취소 여부
 */
  isCancelled?: boolean;

/**
 * 상태
 */
  statusList?: Array<'PENDING' | 'IN_PROGRESS' | 'COMPLETED' | 'CANCELED'>;
}

export function enrollmentScheduleControllerSearchCursorByTicketIdV1(http: HttpClient, rootUrl: string, params: EnrollmentScheduleControllerSearchCursorByTicketIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorSearchEnrollmentScheduleResponseDto>> {
  const rb = new RequestBuilder(rootUrl, enrollmentScheduleControllerSearchCursorByTicketIdV1.PATH, 'get');
  if (params) {
    rb.path('ticketId', params.ticketId, {});
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('cursor', params.cursor, {});
    rb.query('type', params.type, {});
    rb.query('logStatus', params.logStatus, {});
    rb.query('year', params.year, {});
    rb.query('startAt', params.startAt, {});
    rb.query('endAt', params.endAt, {});
    rb.query('centerId', params.centerId, {});
    rb.query('childId', params.childId, {});
    rb.query('isCancelled', params.isCancelled, {});
    rb.query('statusList', params.statusList, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CursorSearchEnrollmentScheduleResponseDto>;
    })
  );
}

enrollmentScheduleControllerSearchCursorByTicketIdV1.PATH = '/api/v1/enrollment-schedule/ticket/cursor/{ticketId}';
